import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import useCtaTracker from "@/lib/useCtaTracker";

export const PageShell = ({ children, testid = "page-shell" }) => {
  useCtaTracker();
  return (
    <SmoothScroll>
      <div className="App relative" data-testid={testid}>
        <Header />
        <main className="pt-28 md:pt-36 pb-24">{children}</main>
        <Footer />
      </div>
    </SmoothScroll>
  );
};

export default PageShell;
